if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){


    if(!(window.ActiveXObject) && "ActiveXObject" in window) {

        //is explorer
        function msieversion() {
            let ua = window.navigator.userAgent;
            let msie = ua.indexOf("MSIE ");
            if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))
            {
                const image_fit = document.getElementsByClassName('image-fit__wrapper');
                for(let i = 0; i < image_fit.length; i++ ){
                    const this_image = image_fit[i].getElementsByTagName('img')[0];
                    const image_data = this_image.dataset.srcset;
                    const image_src = this_image.getAttribute('src');
                    image_fit[i].classList.add('ie-bg');
                    if(image_data){
                        image_fit[i].style.backgroundImage = 'url("'+image_data+'")';
                    }else{
                        image_fit[i].style.backgroundImage = 'url("'+image_src+'")';
                    }

                }
            }
            else
            {
                console.log('other browser');
            }
            return false;
        }
        msieversion();

    } else {
        /*****************************************************
         OBSERVER TO ADD PARALLAX EFFECT
         /*****************************************************/
        let scrollParallax = []
        let scrolled = 0

        // screen height
        let v_height = window.innerHeight
            || document.documentElement.clientHeight
            || document.body.clientHeight;

        function doParallax(elm) {

            let boundes = elm.dataset.parallax.split(",") // get it from html
            //get distance in positive value
            let distance = Math.abs(boundes[0] - boundes[1])
            if (boundes[0] > boundes[1]) {
                //get distance in negative value (to do the scroll inverse)
                distance = distance * -1
            }
            //Equivalent distance using screen height + element height
            const unit_scroll = distance / (v_height + elm.offsetHeight)
            let temp = 0

            let topElement = 0;
            let element = elm;

            let id_elem = elm.dataset.parallaxid

            do {
                topElement += element.offsetTop || 0;
                element = element.offsetParent;
            } while (element)

            let parallaxFunction = function () {
                //Obtain the distance between top screen and document top 0
                scrolled = document.documentElement.scrollTop || window.pageYOffset
                //Distance of bottom page to top of the element
                let relative_distance = scrolled + v_height - topElement
                //transpoling data to move the parallax element relative to the scroll of all the screen
                temp = (unit_scroll * relative_distance) + parseInt(boundes[0])
                //console.log('scroll: '+scrolled+' v_height: '+v_height+' element top: '+elm.offsetTop)
                elm.setAttribute('style', 'transform: translate(0, ' + temp + 'px)')
            }

            scrollParallax[id_elem] = parallaxFunction

            window.addEventListener('scroll', scrollParallax[id_elem])

        }

        let observers_parallax = document.querySelectorAll(".js-parallax-element")

        if (observers_parallax) {
            let options_parallax = {
                root: null, // relative to document viewport
                rootMargin: '0px', // margin around root. Values are similar to css property. Unitless values not allowed
                threshold: 0 // visible amount of item shown in relation to root
            }

            function handler_parallax(entries, observer) {
                let entry;
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        doParallax(entry.target)
                    } else {
                        let id_elem = entry.target.dataset.parallaxid
                        window.removeEventListener('scroll', scrollParallax[id_elem])
                    }
                })
            }

            let observable_parallax = new IntersectionObserver(handler_parallax, options_parallax)
            let counter = 1
            observers_parallax.forEach(function (element) {
                observable_parallax.observe(element)
                element.dataset.parallaxid = counter
                counter++
            })
        }
        /********************************************************************************
         END OF OBSERVER TO ADD PARALLAX EFFECT
         ***********************************************************************************/
    }

    

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });
    $('.reviews').slick({
        fade:true,
        accessibility: false,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    adaptiveHeight: true,
                    autoplay: false,
                }
            }
        ]
    })
    $('.carrousel-slide').slick({
        arrows: true,
        dots: true,
        infinite: true,
        fade: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 500,
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><span class="space-btn"></span>Prev</button>',
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><span class="space-btn"></span>Next</button>',
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    adaptiveHeight: true,
                    autoplay: false,
                }
            }
        ]
    });
    $('.gallery-slider').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        pauseOnHover:false,
        speed: 500,
        fade: true,
        accessibility: true,
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><span class="space-btn"></span>Prev</button>',
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><span class="space-btn"></span>Next</button>',
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
    $('.slider-slide').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 700,
        fade: true,
        accessibility: false,
        prevArrow: '<button class="slick-prev slick-arrow" tabindex="-1" aria-label="Previous" type="button">Prev</button>',
        nextArrow: '<button class="slick-next slick-arrow" tabindex="-1" aria-label="Next" type="button">Next</button>',
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    adaptiveHeight: true,
                }
            }
        ]
    });


    let aBtn = document.querySelectorAll(".btn:not(.attractions-map__expand), .signup-btn");
    if(aBtn){
        setTimeout(() => {
            aBtn.forEach(function(a_btn) {
                let htmlString = a_btn.innerText;
                a_btn.innerHTML = '<div class="btn-lines"></div><span>'+htmlString+'</span>';
            });
        }, "1000");
    }


    //Custom gallery
    const customLightboxFooter = new LBX(".js-my-lightbox", {
        fullScreen:true,
    });


    //Section Animation scroll

    //class for scroll
	let classtoscroll = document.querySelectorAll(".scroll-js");
	if (classtoscroll) {
		classtoscroll.forEach(item =>{
			item.addEventListener("click", (e)=>{
				e.preventDefault();
				let sectiongoto = e.target.hash.split("#")[1];
				animateTo(sectiongoto)
			});
		});
	}

    function animateTo(target) {
        var gotoTarget = offset(document.getElementById(target)).top - 150
        var from = window.pageYOffset
        var to = gotoTarget
        var duration = 1800
        var start = new Date().getTime()
    
        //time interval
        var timer = setInterval(function () {
            var time = new Date().getTime() - start
    
            if (from <= to) {
                var yH = easeInOutQuart(time, from, to - from, duration)
            } else {
                var yH = easeInOutQuart(time, from, -(from - to), duration)
            }
            window.scrollTo(0, yH)
            if (time >= duration) clearInterval(timer)
        }, 1000 / 60)
    
        window.scrollTo(0, from)
    }
    
    //ease movement
    function easeInOutQuart(t, b, c, d) {
        if ((t /= d / 2) < 1) return (c / 2) * t * t * t * t + b
        return (-c / 2) * ((t -= 2) * t * t * t - 2) + b
    }
    
    //window offset
    function offset(el) {
        var rect = el.getBoundingClientRect(),
            scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
            scrollTop = window.pageYOffset || document.documentElement.scrollTop
        return {
            top: rect.top + scrollTop,
            left: rect.left + scrollLeft,
        }
    }
    

})();